/** Normalize account_status from RPC/DB (enum, string, null, etc.). */
export function normalizeAccountStatus(status: unknown): string {
  if (status == null) return '';
  return String(status).toLowerCase().trim();
}

/** True only for explicitly deactivated statuses — never for null/undefined/errors. */
export function isAccountDeactivated(status: unknown): boolean {
  const s = normalizeAccountStatus(status);
  return s === 'inactive' || s === 'suspended';
}

export function isAccountActive(status: unknown): boolean {
  return normalizeAccountStatus(status) === 'active';
}
